import { Plugins } from '@leverege/plugin';

/**
 * A comparator function that compares a.sort and b.sort, assuming
 * a.sort and b.sort are numbers 
 */
function numSortComparator(a, b) {
  const an = a.sort || 0;
  const bn = b.sort || 0;
  return an - bn;
}

/**
 * Returns a sorted array of plugins
 */
function sortedPlugins(pluginType, filter) {
  const plgs = [...Plugins.get(pluginType, filter)];
  plgs.sort(numSortComparator);
  return plgs;
}
async function invokeMoltenCallbacks(pluginType, method, molten, ...rest) {
  const callbacks = sortedPlugins(pluginType);
  for (let n = 0; n < callbacks.length; n++) {
    // eslint-disable-next-line no-await-in-loop
    await callbacks[n][method](molten, ...rest);
  }
}
async function handleHardReload(url = window.location.href) {
  await fetch(url, {
    headers: {
      Pragma: 'no-cache',
      Expires: '-1',
      'Cache-Control': 'no-cache'
    }
  });
  window.location.href = url;
  // This is to ensure reload with url's having '#'
  localStorage.setItem('lastRefresh', new Date().toISOString());
  window.location.reload();
}
export default {
  numSortComparator,
  sortedPlugins,
  invokeMoltenCallbacks,
  handleHardReload
};